import React from 'react';
import getOr from 'lodash/fp/getOr';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

import selectUser from '../../../../store/selectors/appSelector';
import theme from '../../../../theme';
import { updateFavoriteDnr } from '../reducer';

import FavoriteDNRAccordion from './FavoriteDNRAccordion';

const DNR = ({ initialValues }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const favoriteOrDNRData = getOr({}, 'DNR', initialValues);
  const corporation = initialValues;

  const handleOnUpdate = (data) => {
    const postData = {
      id: corporation.id,
      ...data,
    };

    dispatch(updateFavoriteDnr(postData));
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        sx={{
          fontFamily: theme.components.detailView.typography.sectionHeader.fontFamily,
          fontSize: theme.components.detailView.typography.sectionHeader.fontSize,
          color: theme.components.detailView.typography.sectionHeader.fontColor,
        }}
      >
        {' '}
        DNR Employees
      </Typography>
      {favoriteOrDNRData?.map((d) => (
        // eslint-disable-next-line react/no-array-index-key

        <ListItem key={d._id} sx={{ padding: '4px' }}>
          <FavoriteDNRAccordion
            favoriteOrDNR="DNR"
            favoriteOrDNREmployee={d}
            handleOnUpdate={handleOnUpdate}
            corporation={corporation}
            user={user}
          />
        </ListItem>
      ))}
    </Box>
  );
};

export default DNR;
DNR.propTypes = {
  initialValues: PropTypes.shape({}),
};
